import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'

// パートナー設定の売上レポートに関するFeatureFlagsを作成します。
export function createPartnerConfigFeatureFlagsSalesReportPart(spec: ServiceSpecification) {
  return {
    // 旧来のパートナー設定では enableStailerStandardSalesFinalizer (bool) として管理していたが、
    // サービス仕様では「売上確定の方法（画面 or スケジューラー）」として定義し直した。
    // 外部管理画面上でパートナーが手動で売上確定を実施するのは manualFinalization に相当するため、
    // manualFinalization の場合に true を返す。
    get enableStailerStandardSalesFinalizer(): boolean {
      return spec.salesReport?.salesFinalizationMethod.case === 'manualFinalization'
    },
  }
}
